import { ExpandMore } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import { Accordion, AccordionDetails, AccordionSummary, Box, List, ListItemButton, ListItemText, Stack, Typography } from '@mui/material';
import { setAutocolonSelectItem, setGroupSelectedItem } from 'app/actions/transport';
import { Scrollbar } from 'app/components';
import { autocolonSelectedItemTransportSelector, divisionAutocolnSortedItemsTransportSelector } from 'app/selectors/transport';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const Divisions = () => {
    const dispatch = useDispatch();
    const autocolonSelectedItem = useSelector(autocolonSelectedItemTransportSelector);
    const sortItems = useSelector(divisionAutocolnSortedItemsTransportSelector);
    const handleItemClick = (autocolon) => {
        dispatch(setAutocolonSelectItem(autocolon));
        dispatch(setGroupSelectedItem(null));
    };
    const startExpanded = sortItems.reduce((acc, item) => {
        acc[item.id] = true;
        return acc;
    }, {});
    const [expanded, setExtended] = useState(startExpanded);
    const handleAccordionChange = (key) => {
        setExtended(Object.assign(Object.assign({}, expanded), { [key]: !expanded[key] }));
    };
    const handleEditDivision = (e, item) => {
        setExtended(Object.assign(Object.assign({}, expanded), { [item.id]: true }));
        dispatch(setAutocolonSelectItem(item));
        dispatch(setGroupSelectedItem(null));
    };
    return (React.createElement(Box, { sx: {
            width: '100%',
            height: '100%',
            '.simplebar-offset > div': {
                '&::-webkit-scrollbar': {
                    width: 0,
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                    boxShadow: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
        } },
        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                height: '100%',
                '.simplebar-content-wrapper': {
                    padding: theme.spacing(0),
                },
                '.MuiAccordion-root': {
                    borderRadius: '0',
                    overflow: 'hidden',
                    width: '100%',
                    transition: 'background-color ' + theme.transitions.duration.shortest + 'ms ' + theme.transitions.easing.easeInOut + ' 0ms',
                    '&:before': {
                        display: 'none',
                    },
                    '&:last-of-type': {
                        margin: '0!important',
                    },
                    '&.Mui-expanded': {
                        margin: '0',
                    },
                    '&.Mui-disabled': {
                        bgcolor: 'background.paper',
                        '.MuiAccordionSummary-root': {
                            opacity: '1',
                        },
                        '.MuiAccordionSummary-expandIconWrapper': {
                            display: 'none',
                        },
                    },
                    '.MuiAccordionSummary-expandIconWrapper': {
                        svg: {
                            fontSize: '18px',
                        },
                    },
                },
                '.MuiAccordionSummary-root': {
                    padding: theme.spacing(0, 2),
                    minHeight: '24px',
                    transition: 'none',
                    bgcolor: '#f5f6fa',
                    '&:hover': {
                        bgcolor: 'background.default',
                        borderRadius: '0',
                    },
                    '&.Mui-expanded': {
                        minHeight: '24px',
                        borderRadius: '0',
                        '.MuiCheckbox-root': {
                            color: '#FFFFFF',
                            '&.Mui-checked': {
                                color: '#FFFFFF',
                            },
                        },
                        '.MuiAccordionSummary-expandIconWrapper': {},
                    },
                },
                '.MuiAccordionSummary-content': {
                    alignItems: 'center',
                    overflow: 'hidden',
                    margin: theme.spacing(0),
                    '&.Mui-expanded': {
                        margin: theme.spacing(0),
                    },
                    '.MuiCheckbox-root': {
                        minWidth: '26px',
                        justifyContent: 'flex-start',
                        padding: theme.spacing(0),
                        svg: {
                            fontSize: '18px',
                        },
                    },
                },
                '.MuiAccordionDetails-root': {
                    padding: theme.spacing(0),
                    '.MuiList-root': {
                        margin: '2px 0',
                    },
                },
            }) },
            React.createElement(Scrollbar, null, sortItems.map(({ id, name, autocolons }) => {
                const isSelectedDivision = autocolonSelectedItem && autocolonSelectedItem.autocolons && (autocolonSelectedItem === null || autocolonSelectedItem === void 0 ? void 0 : autocolonSelectedItem.id) === id;
                const selectedAutocolonId = autocolonSelectedItem && !autocolonSelectedItem.autocolons ? autocolonSelectedItem.id : undefined;
                return (React.createElement(Stack, { direction: 'row', key: id },
                    React.createElement(Accordion, { square: true, elevation: 0, disabled: autocolons.length === 0, expanded: expanded[id], onChange: () => handleAccordionChange(id), TransitionProps: { unmountOnExit: true } },
                        React.createElement(Stack, { direction: 'row', sx: (theme) => ({
                                position: 'relative',
                                '.MuiAccordionSummary-root': {
                                    width: '100%',
                                    bgcolor: isSelectedDivision ? '#6576ff' : '',
                                    color: isSelectedDivision ? theme.palette.primary.contrastText : 'inherit',
                                    '&:hover': {
                                        bgcolor: isSelectedDivision ? '#838aef' : '',
                                    },
                                },
                            }) },
                            React.createElement(AccordionSummary, { disableRipple: true, expandIcon: React.createElement(ExpandMore, null) },
                                React.createElement(Typography, null,
                                    name,
                                    " (",
                                    autocolons.length,
                                    ")")),
                            React.createElement(EditIcon, { fontSize: 'small', sx: {
                                    fontSize: '0.9em',
                                    position: 'absolute',
                                    right: '30px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                    fill: isSelectedDivision ? '#fff' : '#000',
                                }, onClick: (e) => handleEditDivision(e, {
                                    id,
                                    name,
                                    autocolons,
                                }) })),
                        React.createElement(AccordionDetails, null,
                            React.createElement(List, { disablePadding: true, sx: (theme) => ({
                                    '& .Mui-selected': {
                                        bgcolor: theme.palette.primary.main + '!important',
                                        color: theme.palette.primary.contrastText,
                                    },
                                }) }, autocolons.map((autocolon) => (React.createElement(Stack, { direction: 'row', key: `autocolon${autocolon.id}` },
                                React.createElement(ListItemButton, { selected: autocolon.id === selectedAutocolonId, onClick: () => handleItemClick(autocolon), sx: (theme) => ({
                                        padding: theme.spacing(0.5, 1),
                                        paddingLeft: '36px',
                                        borderRadius: '0',
                                        '&:hover': {
                                            bgcolor: 'background.default',
                                            cursor: 'pointer',
                                        },
                                        '.MuiListItemIcon-root': {
                                            minWidth: '26px',
                                            '.MuiCheckbox-root': {
                                                padding: '0',
                                                minWidth: '26px',
                                                justifyContent: 'flex-start',
                                                svg: {
                                                    fontSize: '18px',
                                                },
                                            },
                                        },
                                        '.MuiListItemText-root': {
                                            margin: theme.spacing(0),
                                        },
                                    }) },
                                    React.createElement(ListItemText, { primary: autocolon.name }))))))))));
            })))));
};
export default Divisions;
